import { SUPER_ADMIN_VERIFY_USERS_SUCCESS, SUPER_ADMIN_UN_PHANTOM_USERS_SUCCESS } from '../types';

interface UsersRequestState {
  verifyEmailsResult: unknown[];
  unPhantomUsersResult: unknown[];
}

interface UsersRequestAction {
  type: string;
  responses: unknown[];
}

const initialState: UsersRequestState = {
  verifyEmailsResult: [],
  unPhantomUsersResult: [],
};

const usersRequest = (
  state: UsersRequestState = initialState,
  action: UsersRequestAction,
): UsersRequestState => {
  switch (action.type) {
    case SUPER_ADMIN_VERIFY_USERS_SUCCESS:
      return { ...state, verifyEmailsResult: action.responses };
    case SUPER_ADMIN_UN_PHANTOM_USERS_SUCCESS:
      return { ...state, unPhantomUsersResult: action.responses };
    default:
      return state;
  }
};

export default usersRequest;
